var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 154,
    viewBox: "0 0 126 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6387_16926)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 11,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#E8E8DB",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7759 39.6311C87.4115 41.2658 87.4115 43.9169 85.7759 45.5516L83.6609 47.6667L76.3359 40.3414L78.451 38.2264C80.0865 36.5912 82.7375 36.5912 84.3726 38.2264L85.7759 39.6311Z",
    fill: "#00ACEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3333 48.744L63.1143 69H63.1128L55 61.256L76.2206 41L84.3333 48.744Z",
    fill: "#00EFD1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.342 61L63.0026 68.6602L62.9313 68.7316L52.3359 71.6667L55.2707 61.0713L55.342 61Z",
    fill: "#FEDB41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5954 67.5517C83.8929 67.5517 83.3235 68.1211 83.3235 68.8236V80.1165C83.321 82.223 81.6144 83.9296 79.5079 83.9321H43.8203C41.7138 83.9296 40.0072 82.223 40.0047 80.1165V46.9727C40.0072 44.8666 41.7138 43.1595 43.8203 43.157H55.1132C55.8157 43.157 56.3851 42.5877 56.3851 41.8852C56.3851 41.1826 55.8157 40.6133 55.1132 40.6133H43.8203C40.3097 40.6173 37.4649 43.4621 37.4609 46.9727V80.1165C37.4649 83.6271 40.3097 86.4719 43.8203 86.4759H79.5079C83.0185 86.4719 85.8633 83.6271 85.8673 80.1165V68.8236C85.8673 68.1211 85.2979 67.5517 84.5954 67.5517Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.3614 37.3408C83.1242 35.1091 79.5033 35.1091 77.2666 37.3408L54.575 60.0324C54.42 60.1879 54.3072 60.3806 54.2486 60.5918L51.2652 71.3635C51.1424 71.8052 51.2671 72.2782 51.5911 72.6026C51.9155 72.9265 52.3885 73.0512 52.8302 72.929L63.6019 69.9451C63.8135 69.8864 64.0068 69.7737 64.1623 69.6181L64.2343 69.5456L86.8529 46.9271C89.0881 44.6923 89.0881 41.069 86.8529 38.8343L85.3614 37.3408ZM56.1495 63.2603L60.9334 68.0447L54.3157 69.878L56.1495 63.2603ZM63.3356 68.6474V68.6464L64.1648 69.4756L63.3356 68.6474ZM63.3356 66.8488L57.3458 60.8591L75.9172 42.2877L81.9065 48.2765L63.3356 66.8488ZM85.0544 45.1286L83.705 46.4779L77.7162 40.4887L79.0656 39.1393C80.3077 37.8997 82.3193 37.8997 83.5619 39.1393L85.0544 40.6333C86.2964 41.8743 86.2964 43.8875 85.0544 45.1286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 9.5,
    width: 103,
    height: 103,
    rx: 51.5,
    stroke: "#E8E8DB",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3202 146.08V148H46.2202V133.64H55.1802V135.56H48.4202V139.64H54.5802V141.56H48.4202V146.08H55.3202ZM56.9798 142.7C56.9798 139.48 58.8198 137.2 61.6798 137.2C63.0998 137.2 64.3398 137.92 65.0798 139.22V133.64H67.0998V148H65.2198V146.1C64.4598 147.44 63.1798 148.2 61.6798 148.2C58.8198 148.2 56.9798 145.88 56.9798 142.7ZM59.0798 142.7C59.0798 145.06 60.3198 146.4 62.0798 146.4C63.7998 146.4 65.0798 145 65.0798 142.66C65.0798 140.28 63.7598 138.98 62.0798 138.98C60.3198 138.98 59.0798 140.3 59.0798 142.7ZM72.3678 134.94C72.3678 135.7 71.7678 136.28 70.9078 136.28C70.0478 136.28 69.4278 135.7 69.4278 134.94C69.4278 134.16 70.0478 133.6 70.9078 133.6C71.7678 133.6 72.3678 134.16 72.3678 134.94ZM71.9278 148H69.9078V137.4H71.9278V148ZM80.712 146.04V147.82C80.092 148.1 79.552 148.2 78.912 148.2C76.952 148.2 75.592 147.14 75.592 144.8V139.12H73.252V137.4H75.592V134.26H77.612V137.4H80.812V139.12H77.612V144.34C77.612 145.8 78.312 146.32 79.392 146.32C79.872 146.32 80.292 146.24 80.712 146.04Z",
    fill: "#E8E8DB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6387_16926",
    x: 0,
    y: 0,
    width: 126,
    height: 126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.647059 0 0 0 0 0.941176 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6387_16926"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.909804 0 0 0 0 0.858824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6387_16926",
    result: "effect2_dropShadow_6387_16926"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_6387_16926",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNew);
export default __webpack_public_path__ + "static/media/edit-new.9e0ef8e76e3a201d984f084389fdaa2e.svg";
export { ForwardRef as ReactComponent };